import React from 'react';
import { useRecentProjects } from '../../hooks/useRecentProjects';
import { ProjectCard } from './ProjectCard';
import { RefreshCw, Trash2, Loader2 } from 'lucide-react';
import { IconButton } from '../common/IconButton';

export const RecentProjects: React.FC = () => {
  const {
    projects,
    isLoading,
    openProject,
    clearAll,
    removeProject,
    refresh,
  } = useRecentProjects();

  return (
    <div className="bg-gray-800 rounded-lg border border-gray-700">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
        <h3 className="text-sm font-medium text-white">Recent Projects</h3>
        <div className="flex items-center gap-1">
          <IconButton
            icon={<Trash2 size={16} />}
            onClick={clearAll}
            title="Clear All"
            size="sm"
            disabled={projects.length === 0 || isLoading}
          />
          <IconButton
            icon={<RefreshCw size={16} className={isLoading ? 'animate-spin' : ''} />}
            onClick={refresh}
            title="Refresh"
            size="sm"
            disabled={isLoading}
          />
        </div>
      </div>

      <div className="max-h-72 overflow-y-auto">
        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-6 h-6 animate-spin text-gray-500" />
          </div>
        ) : projects.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 text-gray-500">
            <p>No recent projects</p>
            <p className="text-sm mt-1">Create a new project to get started</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-700">
            {projects.slice(0, 10).map((project) => (
              <ProjectCard
                key={project.path}
                project={project}
                onOpen={() => openProject(project.path)}
                onRemove={() => removeProject(project.path)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
